<template>
  <div class="userWrapper">
    <div class="dropDown workDropDown" @click="switchCenter" v-if="centerVos.length >= 1">
      <div class="workSite">
        <span class="userName">{{currentCenterName}}</span>
      </div>
    </div>
    <Dropdown class="dropDown userMenuDropDown" placement="bottomLeft">
      <div class="userAvatar">
        <span class="userName">{{userInfo.real_name}}</span>
      </div>
      <Menu slot="overlay" @click="handleClick">
        <!-- <MeunItem key="updatePwd">
          <Icon type="setting"/>
          <span>修改密码</span>
        </MeunItem> -->
        <MeunItem key="logout">
          <Icon type="logout"/>
          <span>退出登录</span>
        </MeunItem>
      </Menu>
    </Dropdown>
    <!-- 修改密码 -->
    <Modal title="修改密码" v-model="updatePwd.openFlag" v-if="updatePwd.openFlag" @ok="resetPwd">
      <Form :form="updatePwd.form">
        <FormItem label="原密码" v-bind="updatePwd.formItemLayout" required>
          <Input size="large" type="password" placeholder="请输入原密码" v-decorator="['oldPwd',{rules:[{required: true, message: '请输入原密码'}]}]"/>
        </FormItem>
        <FormItem label="新密码" v-bind="updatePwd.formItemLayout" required>
          <Input size="large" type="password" placeholder="请输入新密码" v-decorator="['pwd',{rules:[{required: true, message: '请输入新密码'}]}]"/>
        </FormItem>
        <FormItem label="确认密码" v-bind="updatePwd.formItemLayout" required>
          <Input size="large" type="password" placeholder="请输入新密码" v-decorator="['confirmPwd',{rules:[{required: true, message: '请输入新密码'}]}]"/>
        </FormItem>
      </Form>
    </Modal>  
    <!-- 选择影像中心 -->
    <Modal v-if="centerVos.length > 1" class="selectCenterModal userModal"  title="选择影像中心" v-model="showSelectWorkPlace" cancelText="取消" okText="确认" @ok="selectCenter" @cancel="closeSelectCenter">
      <RadioGroup v-model="selectCenterId">
        <div style="margin-bottom: 15px" v-for="item in centerVos" :key="item.id">
          <Radio :value="item.id">{{item.name}}</Radio>
        </div>
      </RadioGroup>
    </Modal>
  </div>
</template>
<script>
import { Dropdown, Menu, Icon, Modal, Form, Input, Radio } from 'ant-design-vue'
import { LoginUser, SelectCenter } from '../../libs/mixin'
import { mapState } from 'vuex'
import { getLocal, toast } from '../../libs/utils'
import { updatePwd } from '../../api/user'
import md5 from 'md5'
export default {
  components: {
    Dropdown,
    Menu,
    MeunItem: Menu.Item,
    Icon,
    Form,
    FormItem: Form.Item,
    Input,
    Modal,
    Radio,
    RadioGroup: Radio.Group
  },
  mixins: [LoginUser, SelectCenter],
  data () {
    return {
      updatePwd: {
        form: '',
        openFlag: false,
        formItemLayout: {
          labelCol: {
            xs: { span: 24 },
            sm: { span: 4 },
          },
          wrapperCol: {
            xs: { span: 24 },
            sm: { span: 20 },
          }
        }
      }
    }
  },
  methods: {
    async handleClick (item) {
      if (item.key === 'logout') {
        Modal.confirm({
          title: '提示',
          content: '真的要注销登录吗 ?',
          onOk: async () => {
            await this.logoutHandle()
          }
        })
      }
      if (item.key === 'updatePwd') {
        this.updatePwd.form = this.$form.createForm(this)
        this.updatePwd.openFlag = true
      }
    },
    switchCenter () {
      let lastCenter = getLocal('lastCenter', 'object') || null
      this.showSelectWorkPlace = true
      if (lastCenter && lastCenter.userId === this.userInfo.id) {
        this.selectCenterId = lastCenter.id
      } else {
        this.selectCenterId = this.centerVos[0]['id']
      }
    },
    async resetPwd () {
      const { form: { getFieldsValue, setFields } } = this.updatePwd
      let data = getFieldsValue(['oldPwd', 'pwd', 'confirmPwd'])
      if (!data.oldPwd || !data.oldPwd.trim()) return setFields({oldPwd: {value: '', errors: [new Error('请输入原密码')]}})
      if (!data.pwd || !data.pwd.trim()) return setFields({pwd: {value: '', errors: [new Error('请输入新密码')]}})
      if (!data.confirmPwd || !data.confirmPwd.trim()) return setFields({confirmPwd: {value: '', errors: [new Error('请再次输入新密码')]}})
      if (data.pwd.trim()!== data.confirmPwd.trim()) {
        return setFields({confirmPwd: {value: data.confirmPwd.trim(), errors: [new Error('两次输入的新密码不一致')]}})
      }
      let updateVal = await updatePwd ({id: this.userInfo.id, password: md5(data.confirmPwd.trim())})
      if (updateVal) {
        this.updatePwd.openFlag = false
        toast({msg: '您已成功修改密码', title: '提示', type: 'success'})
      }
    },
    closeSelectCenter () {
      this.showSelectWorkPlace = false
    }
  },
  computed: {
    ...mapState({
      currentCenterName: state => state.app.currentCenterName
    })
  }
}
</script>
<style lang="less">
.userWrapper{
  display: flex;
  .dropDown{
    cursor: pointer;
  }
  .userAvatar{
    padding: 0 12px;
    .userName{
      margin-left: 10px;
    }
  }
  @media screen and (max-width: 576px) {
    .userAvatar{
      .userName{
        display: inline-block;
        width: 50px;
      }
    }
  }
}
.selectCenterModal{
  .ant-modal-body{
    max-height: 520px;
    overflow: auto;
  }
}
.selectCentVos .ant-modal-content .centerWrap{
  max-height: 500px;
  overflow: auto;
}
@media screen and (max-width: 576px) {
  .ant-layout-header{
    padding-right: 16px;
  }
}
@media all and (max-width: 767px) {
  .userModal{
    padding: 0 5px;
    .ant-modal-body{
      max-height: 300px !important;
      overflow: auto;
    }
  }
}
</style>